import React from 'react'
import InputDateUI from './InputDateUI'

const InputTimeUI = ({ startTime = '00:00', endTime = '23:45', placeholder = 'Select time', ...props }) => (
  <InputDateUI
    {...props}
    placeholder={placeholder}
    showTimeSelect={true}
    showTimeSelectOnly={true}
    timeIntervals={15}
    startTime={startTime}
    endTime={endTime}
  />
)

export default InputTimeUI
